import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Seoresults() {
  return (
    <section
      className="seo_results vendor-portal-process p-100"
      style={{ background: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <h2>
              Our Optimized Process for <span>Vendor Portal</span> Development
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              We assist in selecting the ideal type of vendor portal to match
              your business needs  and also advice you on changes that may be
              required to the portal. We start with
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
            <div className="seo-result-main">
              <div className="seo-result-item">
                <div className="seo-result-box">
                  <div className="seo-num">01</div>
                  <h5>Planning & Analysis</h5>
                  <p>
                    During the project's beginning phase, our team develops
                    goals and specifications for the vendor portal, solicits
                    feedback from stakeholders, and describes key components of
                    the future vendor portal, such as vendor registration, order
                    management, and payment. We also outline the portal's
                    architectural framework and technology stack, which will
                    direct its evolution.
                  </p>
                </div>
              </div>
              <div className="seo-result-item">
                <div className="seo-result-box">
                  <div className="seo-num">02</div>
                  <h5>UX & UI design</h5>
                  <p>
                    During this phase, we work to design an interface that is
                    simple to use, visually appealing, and expressive of your
                    brand. We begin by brainstorming ideas for KPI dashboards
                    and creating detailed wireframes to explain user flow for
                    critical activities like registration and ordering.
                    Clickable prototypes are made from wireframes for usability
                    testing and improvement. For a polished appearance, we then
                    add a UI kit and full-color images to complete the design.
                  </p>
                </div>
              </div>
              <div className="seo-result-item">
                <div className="seo-result-box">
                  <div className="seo-num">03</div>
                  <h5>Iterative Development</h5>
                  <p>
                    Moving on to the following step, we establish the
                    development, staging, and production frameworks before
                    developing the front-end, back-end, and APIs, as well as
                    interfacing with systems like ERP and CRM. We also address
                    complex issues like as security, high traffic, and
                    maintaining compliance with best practices such as GDPR and
                    PCI DSS.
                  </p>
                </div>
              </div>
              <div className="seo-result-item">
                <div className="seo-result-box">
                  <div className="seo-num">04</div>
                  <h5>Testing & Deployment</h5>
                  <p>
                    Our QA specialists then conduct functional, integration,
                    compatibility, performance, and security tests. Once we've
                    identified these issues and completed user acceptability
                    testing, we'll take the portal live. After installing the
                    system, we collect data from users to evaluate their
                    opinions and incorporate them into the system.
                  </p>
                </div>
              </div>
              <div className="seo-result-item">
                <div className="seo-result-box">
                  <div className="seo-num">05</div>
                  <h5>Ongoing Support & Maintenance</h5>
                  <p>
                    To ensure clear instructions for vendors and employees, we
                    include an FAQ section, video tutorials, and a user guide.
                    We also offer a support line for onboarding and technical
                    issues. For long-term functionality, we perform ongoing
                    maintenance, including site monitoring, issue resolution,
                    updates, security patches, and feature enhancements based on
                    user feedback.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Seoresults;
